<mat-toolbar class="custom-toolbar border-bottom bg-white px-3">
  
  <mat-icon color="primary" class="toolbar-logo-icon me-2">circle</mat-icon>
  
  @defer (when data.name !== '') {
    <span class="toolbar-title fw-semibold text-dark">{{ data.name }}</span>
  } @placeholder {
    <div class="skeleton-title-loader d-flex gap-1 align-items-center">
      <div class="skeleton-dot"></div>
      <div class="skeleton-dot"></div>
      <div class="skeleton-dot"></div>
    </div>
  }
  
  <span class="title-spacer flex-grow-1"></span>

  @if (data.back) {
    <button (click)="back()" matTooltip="Retour" mat-icon-button color="primary" class="me-2" aria-label="Retourner à la page précédente">
      <mat-icon>arrow_back</mat-icon>
    </button>
  }
</mat-toolbar>
